import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import AppLogo from '../AppLogo';

const Footer = ({ scrollTo }) => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  const columns = [
    {
      title: t('footerProduct'),
      links: [
        { label: t('navBenefits'), action: () => scrollTo('benefits') },
        { label: t('navSolutions'), action: () => scrollTo('solutions') },
        { label: t('navDemo'), action: () => scrollTo('demo') },
        { label: t('navTrust'), action: () => scrollTo('trust') },
      ],
    },
    {
      title: t('footerCompany'),
      links: [
        { label: t('footerContact'), action: () => navigate('/contact') },
        { label: t('createCompany'), action: () => navigate('/register-company') },
      ],
    },
    {
      title: t('footerSupport'),
      links: [
        { label: t('footerHelpCenter'), action: () => navigate('/help') },
        { label: t('trackAPackage'), action: () => navigate('/track') },
        { label: t('login'), action: () => navigate('/login') },
      ],
    },
    {
      title: t('footerLegal'),
      links: [
        { label: t('footerPrivacy'), action: () => navigate('/privacy') },
        { label: t('footerTerms'), action: () => navigate('/terms') },
      ],
    },
  ];

  return (
    <footer className="landing-footer">
      <div className="landing-footer-inner">
        <div className="landing-footer-grid">
          <div>
            <div className="landing-nav-logo" style={{ marginBottom: 0 }}>
              <div className="landing-nav-logo-icon"><AppLogo size={24} /></div>
              FretManager
            </div>
            <p className="landing-footer-brand">{t('footerBrandDesc')}</p>
          </div>
          {columns.map((col) => (
            <div key={col.title}>
              <div className="landing-footer-col-title">{col.title}</div>
              <ul className="landing-footer-links">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <button type="button" onClick={l.action}>{l.label}</button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="landing-footer-bottom">
          <p>&copy; {new Date().getFullYear()} FretManager. {t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
